<span class="khts-mat-dialog-title headline-small"><ng-content></ng-content></span>
